function lt(number) {
  return function check(value) {
    return parseFloat(value) < parseFloat(number);
  };
}

export default lt;
